import { render, staticRenderFns } from "./newNotice.vue?vue&type=template&id=4c609b3f&scoped=true&"
import script from "./newNotice.vue?vue&type=script&lang=js&"
export * from "./newNotice.vue?vue&type=script&lang=js&"
import style0 from "./newNotice.vue?vue&type=style&index=0&id=4c609b3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c609b3f",
  null
  
)

export default component.exports